import { useEffect, useState } from "react";
import { HyperFlow } from "../../hyperFlowAPI";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import {
  addFileToExecFlow,
  clearValidComponentError,
  confirmValidProcessById,
  getValidConfigByProcessId,
  getValidProcessById,
  resetFlow,
  selectHFValidComponentConfig,
  selectHFValidComponentConfigLoading,
  selectHFValidComponentDocumentConfigs,
  selectHFValidComponentError,
  selectHFValidComponentProcess,
  selectHFValidComponentProcessConfirmed,
  selectHFValidComponentProcessLoading,
} from "../../hyperFlowSlice";
import { ClipLoader } from "react-spinners";
import {
  ATKDocumentConfig,
  ATKProcess,
  ATKProcessConfig,
  ATKProcessDocument,
  downloadDocumentAPI,
} from "../../../authentikator/AuthentikatorAPI";
import fileDownload from "js-file-download";
import Modal, { Styles } from "react-modal";

const customStylesModal3: Styles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",

    width: "40%",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1%",
  },
  overlay: {
    background: "rgba(0,0,0,0.6)",
  },
};
Modal.setAppElement("#root");

export interface ValidAttachmentComponentProps {
  execFlow: HyperFlow;
  stepId: string;
}

export const ValidAttachmentComponent: React.FC<
  ValidAttachmentComponentProps
> = ({ execFlow, stepId }) => {
  const dispatch = useAppDispatch();
  // App Selectors
  const loadingConfig = useAppSelector(selectHFValidComponentConfigLoading);
  const loadingProcess = useAppSelector(selectHFValidComponentProcessLoading);
  const process = useAppSelector(selectHFValidComponentProcess);
  const processConfig = useAppSelector(selectHFValidComponentConfig);
  const documentConfigs = useAppSelector(selectHFValidComponentDocumentConfigs);
  const error = useAppSelector(selectHFValidComponentError);
  const processConfirmed = useAppSelector(
    selectHFValidComponentProcessConfirmed,
  );
  //Local states
  let [selectedDocument, setSelectedDocument] =
    useState<ATKProcessDocument | null>(null);
  let [selectedDocumentId, setSelectedDocumentId] = useState<string | null>(
    null,
  );
  let [showModalUpload, setShowModalUpload] = useState(false);
  let [uploadDisabled, setUploadDisabled] = useState(true);
  let [selectedFile, setSelectedFile] = useState<File | null>(null);
  let [selectedFileBase64, setSelectedFileBase64] = useState<string | null>(
    null,
  );
  let [fileName, setFileName] = useState<string | null>(null);

  const step = execFlow.executedSteps
    ? execFlow.executedSteps[stepId]
    : undefined;

  //Helper functions
  const getUploadedTag = (doc: ATKProcessDocument) => {
    if (doc.uploaded && doc.validityScore >= 50) {
      return (
        <div
          style={{
            background: "rgba(96, 255, 82, 0.69)",
            borderRadius: "8px",
            fontSize: "12px",
            padding: "5px",
          }}
        >
          Cargado: Válido
        </div>
      );
    } else if (doc.uploaded && doc.validityScore < 50) {
      return (
        <div
          style={{
            background: "rgba(255, 173, 35, 0.84)",
            borderRadius: "8px",
            fontSize: "12px",
            padding: "5px",
          }}
        >
          Cargado: No Válido
        </div>
      );
    } else {
      return (
        <div
          style={{
            background: "rgb(255, 92, 92)",
            borderRadius: "8px",
            fontSize: "12px",
            padding: "5px",
          }}
        >
          No cargado
        </div>
      );
    }
  };

  const getDocumentTypeByExtension = (fileName: string) => {
    let extension = fileName.split(".").pop();
    if (extension === "pdf") {
      return "application/pdf";
    } else if (extension === "png") {
      return "image/png";
    } else if (extension === "jpeg" || extension === "jpg") {
      return "image/jpg";
    } else {
      return "application/pdf";
    }
  };

  const getDocumentDescription = (
    id: string,
    docConfigsLocal: { [key: string]: ATKDocumentConfig },
  ) => {
    return docConfigsLocal[id]?.description ?? "";
  };

  const getDocumentNameFromId = (
    id: string,
    localProcess: ATKProcess,
    docConfigsLocal: { [key: string]: ATKDocumentConfig },
  ) => {
    let docConfigId = localProcess?.documents.find(
      (doc) => doc.documentId === id,
    )?.documentConfigId;
    console.log(docConfigId);
    return getDocumentName(docConfigId ?? "", docConfigsLocal);
  };

  const closeErrorModal = () => {
    dispatch(clearValidComponentError());
  };

  const downloadDocument = async (
    processId: string,
    documentId: string,
    localProcess: ATKProcess,
    docConfigsLocal: { [key: string]: ATKDocumentConfig },
  ) => {
    let resp = await downloadDocumentAPI(processId, documentId);
    if (
      resp.result === false ||
      resp.data === undefined ||
      resp.data?.docBase64 === "" ||
      resp.data?.docBase64 === null ||
      resp.data?.fileName === "" ||
      resp.data?.fileName === null
    ) {
      alert("Error al descargar el documento");
      return;
    }
    let url = `data:${getDocumentTypeByExtension(resp.data?.fileName)};base64,${
      resp.data?.docBase64
    }`;

    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        fileDownload(
          blob,
          `${processId}_${getDocumentNameFromId(
            documentId,
            localProcess,
            docConfigsLocal,
          ).replace(" ", "-")}_${resp.data?.fileName}`,
        );
      });
  };

  const getDocumentName = (
    id: string,
    docConfigsLocal: { [key: string]: ATKDocumentConfig },
  ) => {
    return docConfigsLocal[id]?.name ?? "";
  };

  const canConfirmProcess = (process: ATKProcess) => {
    let canConfirmProcess = true;
    process.documents.forEach((doc) => {
      if (!doc.uploaded || doc.validityScore < 50) {
        canConfirmProcess = false;
      }
    });
    return canConfirmProcess;
  };

  const closeUploadModal = () => {
    setShowModalUpload(false);
    setSelectedFile(null);
    setSelectedFileBase64(null);
    setFileName(null);
    setUploadDisabled(true);
  };

  //Components

  const modalUploadView = (
    processLocal: ATKProcess,
    docConfigsLocal: {
      [key: string]: ATKDocumentConfig;
    },
  ) => {
    return (
      <Modal
        isOpen={showModalUpload}
        onRequestClose={() => {
          closeUploadModal();
        }}
        style={customStylesModal3}
        contentLabel="SubirDocumento"
        shouldCloseOnOverlayClick={true}
      >
        {loadingProcess === "pending" ? (
          <div
            className="flex-col"
            style={{
              height: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <ClipLoader color="#49829C" size={200} />
            <p style={{ color: "black" }}>Cargando documento...</p>
          </div>
        ) : (
          <div
            className="flex-col"
            style={{
              height: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            {" "}
            <div
              className="flex-row"
              style={{
                justifyContent: "end",
                alignItems: "end",
                marginTop: "10px",
                marginBottom: "10px",
                marginRight: "10px",
                width: "100%",
              }}
            >
              <button
                onClick={() => {
                  closeUploadModal();
                }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "none",
                  textAlign: "center",
                  borderRadius: "8px",
                  fontSize: "24px",
                  background: "#1A617D",
                  width: "40px",
                  height: "35px",
                  color: "white",
                }}
              >
                X
              </button>
            </div>
            <h4 style={{ fontSize: "20px", fontWeight: 700, color: "#000" }}>
              Cargar documento:{" "}
              {getDocumentName(
                selectedDocument?.documentId ?? "",
                docConfigsLocal,
              )}
            </h4>
            <p
              style={{
                fontSize: "16px",
                fontWeight: 500,
                color: "#000",
                width: "80%",
              }}
            >
              {getDocumentDescription(
                selectedDocument?.documentId ?? "",
                docConfigsLocal,
              )}
            </p>{" "}
            <input
              type="file"
              onChange={(event) => {
                let file = event?.target?.files?.[0];
                if (file) {
                  setSelectedFile(file);
                  setFileName(file.name);
                  // setUploadDisabled(false);
                }
              }}
            />
            <div
              className="flex-row"
              style={{
                justifyContent: "space-evenly",
                alignItems: "center",
                height: "100px",
              }}
            >
              <div
                className="flex-row text-bold primary-color"
                style={{
                  fontSize: "13px",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "black",
                }}
              >
                <button
                  onClick={() => {
                    if (
                      selectedDocument?.documentId &&
                      selectedFileBase64 &&
                      fileName &&
                      processLocal?.id
                    ) {
                      dispatch(
                        addFileToExecFlow({
                          documentId: selectedDocument?.documentId,
                          fileName: fileName,
                          fileBase64: selectedFileBase64,
                          execFlowId: execFlow.id,
                          stepId: stepId,
                        }),
                      ).then(() => {
                        closeUploadModal();
                      });
                    } else {
                      alert("Falta algo");
                    }
                  }}
                  disabled={uploadDisabled}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "none",
                    textAlign: "center",
                    borderRadius: "8px",
                    fontSize: "24px",
                    background: uploadDisabled === true ? "#808080" : "#1A617D",
                    width: "200px",
                    height: "35px",
                    color: "white",
                  }}
                >
                  Subir
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>
    );
  };

  const modalError = () => {
    return (
      <Modal
        isOpen={error !== null && error !== ""}
        onRequestClose={() => {
          closeErrorModal();
        }}
        style={customStylesModal3}
        contentLabel="Advertencia"
        shouldCloseOnOverlayClick={true}
      >
        <div
          className="flex-col"
          style={{
            height: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {" "}
          <div
            className="flex-row"
            style={{
              justifyContent: "end",
              alignItems: "end",
              marginTop: "10px",
              marginBottom: "10px",
              marginRight: "10px",
              width: "100%",
            }}
          >
            <button
              onClick={() => {
                closeErrorModal();
              }}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
                textAlign: "center",
                borderRadius: "8px",
                fontSize: "24px",
                background: "#1A617D",
                width: "40px",
                height: "35px",
                color: "white",
              }}
            >
              X
            </button>
          </div>
          <div className="flex-row">
            <h4 style={{ fontSize: "20px", fontWeight: 700, color: "#000" }}>
              Advertencia:
            </h4>
          </div>
          <div className="flex-row">
            <h4 style={{ fontSize: "16px", fontWeight: 600, color: "#000" }}>
              {error}
            </h4>
          </div>
        </div>
      </Modal>
    );
  };

  const getDocumentView = (
    currentProcessLocal: ATKProcess | null,
    docConfigsLocal: { [key: string]: ATKDocumentConfig },
    selectedDocumentLocal: ATKProcessDocument | null,
  ) => {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          // background: "rgba(0,0,0,0.4)",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            // background: "rgba(0,0,0,0.4)",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {modalUploadView(currentProcessLocal, docConfigsLocal)}
          {modalError()}
          {/* Document list */}
          <div
            style={{
              width: "30%",
              height: "100%",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              overflowY: "scroll",
            }}
          >
            {currentProcessLocal?.documents.map((doc, index) => {
              return (
                <div
                  onClick={() => {
                    setSelectedDocument(doc);
                    setSelectedDocumentId(doc.documentId);
                  }}
                  key={doc.documentId}
                  style={{
                    background:
                      selectedDocumentLocal?.documentId === doc.documentId
                        ? "rgba(0,0,0,0.7)"
                        : "rgba(0,0,0,0.2)",
                    borderRadius: "8px",
                    marginBottom: "10px",
                    padding: "10px",
                    width: "100%",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                  }}
                >
                  <div className="flex-col">
                    {getDocumentName(doc.documentId, docConfigsLocal)}
                  </div>
                  <div className="flex-col">{getUploadedTag(doc)}</div>
                </div>
              );
            })}
          </div>
          {/* Document Detail */}
          {selectedDocumentLocal !== null && (
            <div
              style={{
                width: "70%",
                height: "100%",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
                fontSize: "18px",
              }}
            >
              <div className="flex-col justify-content-between align-items-start">
                <div className="flex-col">
                  <h1 style={{ fontSize: "16px" }}>
                    Nombre del archivo: {selectedDocumentLocal.providedFileName}
                  </h1>
                </div>
                <div
                  className="flex-col"
                  style={{ marginRight: "20px", marginBottom: "10px" }}
                >
                  {selectedDocumentLocal.uploaded && (
                    <button
                      onClick={() => {
                        downloadDocument(
                          currentProcessLocal?.id ?? "",
                          selectedDocumentLocal.documentId,
                          currentProcessLocal,
                          docConfigsLocal,
                        );
                      }}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "none",
                        textAlign: "center",
                        borderRadius: "8px",
                        // background:
                        //   currentSection === "documents"
                        //     ? "rgba(0,0,0,0.6)"
                        //     : "rgba(0,0,0,0.2)",
                        background: "rgba(0,0,0,0.2)",
                        width: "250px",
                        height: "40px",
                        color: "white",
                      }}
                    >
                      Descargar documento
                    </button>
                  )}
                </div>
                <div className="flex-col">
                  <button
                    onClick={() => {
                      setShowModalUpload(true);
                    }}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "none",
                      textAlign: "center",
                      borderRadius: "8px",
                      // background:
                      //   currentSection === "documents"
                      //     ? "rgba(0,0,0,0.6)"
                      //     : "rgba(0,0,0,0.2)",
                      background: "rgba(0,0,0,0.2)",
                      width: "300px",
                      height: "40px",
                      color: "white",
                    }}
                  >
                    {selectedDocumentLocal.uploaded
                      ? "Reemplazar documento"
                      : "Cargar documento"}
                  </button>
                </div>
              </div>
              <div
                className="flex-row"
                style={{ marginTop: "20px", fontSize: "18px" }}
              >
                Validez: {selectedDocumentLocal.validityScore}%
              </div>
              <div className="flex-row" style={{ fontSize: "14px" }}>
                Detalle de validez: {selectedDocumentLocal.validityReason}
              </div>
              {/* {getDataTable(selectedDocumentLocal)} */}
            </div>
          )}
        </div>
        <button
          onClick={() => {
            dispatch(
              confirmValidProcessById({
                execFlowId: execFlow.id,
                stepId: stepId,
              }),
            );
          }}
          disabled={!canConfirmProcess(currentProcessLocal!)}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            textAlign: "center",
            borderRadius: "8px",
            marginTop: "30px",

            background: canConfirmProcess(currentProcessLocal)
              ? "rgba(0,0,0,0.2)"
              : "rgba(0,0,0,0.8)",
            width: "250px",
            height: "40px",
            color: canConfirmProcess(currentProcessLocal) ? "white" : "gray",
          }}
        >
          Confirmar adjuntos
        </button>
      </div>
    );
  };

  // UseEffects

  useEffect(() => {
    if (step.entityId !== undefined) {
      console.log(
        "Fetching Valid attachment data for processId:",
        step.entityId,
      );
      dispatch(getValidConfigByProcessId(step.entityId));
      dispatch(getValidProcessById(step.entityId));
    }
  }, []);

  useEffect(() => {
    if (processConfirmed) {
      dispatch(resetFlow());
    }
  }, [processConfirmed]);

  useEffect(() => {
    if (process && selectedDocumentId) {
      let doc =
        process.documents.find((d) => d.documentId === selectedDocumentId) ??
        null;
      setSelectedDocument(doc);
    }
  }, [process, selectedDocumentId]);

  useEffect(() => {
    if (selectedFile) {
      let reader = new FileReader();
      reader.readAsDataURL(selectedFile);
      reader.onload = function () {
        setSelectedFileBase64(reader.result?.toString().split(",")[1] ?? "");
        setUploadDisabled(false);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
        alert("error");
        setUploadDisabled(true);
      };
    }
  }, [selectedFile]);

  if (step.stepDescriptionId !== "BACK_OFFICE_VALID_ATT") {
    return (
      <div style={{ color: "white" }}>
        <h1>Invalid step: {step.stepDescriptionId}</h1>
      </div>
    );
  }
  if (step.entityId === undefined) {
    return (
      <div style={{ color: "white" }}>
        <h1>Invalid step: missing entityId</h1>
      </div>
    );
  }

  if (
    loadingConfig === "pending" ||
    loadingProcess === "pending" ||
    loadingConfig === "idle" ||
    loadingProcess === "idle"
  ) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <ClipLoader color="white" size="150px" />
      </div>
    );
  }

  return (
    <div style={{ color: "white" }}>
      {getDocumentView(process, documentConfigs, selectedDocument)}
    </div>
  );
};
